import type { FC } from "react";
import { useTranslation } from "react-i18next";
import SystemDialog from "../../UIToolkit/Popups/Dialog";
import { CallOffChoiceDialog } from "./CallOffChoiceDialog";
import type { RemoveStaffSubmit } from "./useRemoveStaffSubmit";

/** The removal's confirmations: "this changes worked hours" (actuals in a synced department), then the call-off choice. */
export const RemoveStaffDialogs: FC<Pick<RemoveStaffSubmit, "choiceDialog" | "payrollDialog">> = ({ choiceDialog, payrollDialog }) => {
	const { t } = useTranslation();
	return (
		<>
			<SystemDialog
				open={payrollDialog.open}
				onClose={payrollDialog.onCancel}
				title={t("confirm.removal")}
				body={t("actual.hours.warning")}
				onConfirm={payrollDialog.onConfirm}
				cancelButtonVariant="secondary"
				confirmButtonVariant="primary"
				confirm={t("confirm")}
				cancel={t("cancel")}
				dataTestId="remove-staff-payroll-dialog"
				confirmDataTestId="remove-staff-payroll-confirm"
				cancelDataTestId="remove-staff-payroll-cancel"
			/>
			<CallOffChoiceDialog {...choiceDialog} />
		</>
	);
};
